module.exports = __webpack_public_path__ + "static/media/check.39741605.svg";